import React from 'react';
import StyledTitle from '../StyledTitle/StyledTitle';
import './Testimonial.scss';
import Carousel from 'react-elastic-carousel';
const breakPoints = [
    { width: 1, itemsToShow: 1 },
];
const Testimonial=()=>{
    return(
        <div className="testimonials">

<StyledTitle 
title="Get real work done"
/>
<Carousel className="slider" breakPoints={breakPoints}>
    <div className="box box1">
<div className="content">
<p>“We are designing for a global user base... [With HostDesign] we can get feedback not just from drivers we see in San Francisco but from all around the world."</p>
<h2>Molly Nix</h2>
<p className="job">Senior Product Designer at Uber</p>
</div>
    </div>
    <div className="box box2">
<div className="content">
<p>“We are designing for a global user base... [With HostDesign] we can get feedback not just from drivers we see in San Francisco but from all around the world."</p>
<h2>Molly Nix</h2>
<p className="job">Senior Product Designer at Uber</p>
</div>
    </div>
    <div className="box box3">
<div className="content">
<p>“We are designing for a global user base... [With HostDesign] we can get feedback not just from drivers we see in San Francisco but from all around the world."</p>
<h2>Molly Nix</h2>
<p className="job">Senior Product Designer at Uber</p>
</div>
    </div>
</Carousel>
        </div>
    )
};
export default Testimonial ;